export default __webpack_public_path__ + "static/media/share.ce266a0c.svg";